import cx from 'classnames';

export interface ChevronLeftIconProps {
  theme?: 'dark' | 'light';
  className?: string;
}

const ChevronLeftIcon: React.FC<ChevronLeftIconProps> = ({ theme, className }) => (
  <svg className={className} width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.45221 13L1.27148 7L7.45221 1"
      stroke={cx({
        '#0F172A': theme === 'light',
        '#FFFFFF': theme === 'dark',
      })}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ChevronLeftIcon;
